var map = {
	"./en-001": [
		1229,
		0
	],
	"./en-001.json": [
		1229,
		0
	],
	"./en_CA": [
		1230,
		1
	],
	"./en_CA.json": [
		1230,
		1
	],
	"./en_US": [
		1231,
		2
	],
	"./en_US.json": [
		1231,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1001;
module.exports = webpackAsyncContext;